import { useState } from "react";
import {
    RedeemCode,
    LinkToast,
} from "../styles/styles";
import { InitialData } from "../types";
import { useTranslation } from "react-i18next";
import { IoMdCopy } from "react-icons/io";

type RedeemCodeProp = {
    data: InitialData;
    isExpired: boolean;
}

export const RedeemCodeContainer = ({ data, isExpired }: RedeemCodeProp) => {

    const { t } = useTranslation();
    const [showMessage, setShowMessage] = useState<boolean>(false);

    const copyToClipboard = () => {
        if (data?.coupon_code) {
            if (navigator?.clipboard?.writeText) {
                navigator.clipboard
                    .writeText(data.coupon_code)
                    .then(() => {
                        setShowMessage(true);
                        setTimeout(() => { setShowMessage(false); }, 2000);
                    })
                    .catch((err) => {
                        console.error("Failed to copy: ", err);
                    });
            } else {
                console.error("Clipboard API is not supported in this browser.");
            }
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", alignContent: "Center", gap: "5px" }}>
            <RedeemCode
                mt={1}
                sx={{
                    color: isExpired ? "#DADADA" : "#000000",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    maxWidth: "220px"
                }}
            >
                {data?.coupon_code}
            </RedeemCode>
            {
                data?.coupon_used_option === "COUPON_WITH_INSTRUCTIONS" &&
                <IoMdCopy size={30} style={{ marginBottom: "-5px" }} onClick={copyToClipboard} />
            }
            {showMessage && <LinkToast>{t("linkCopied")}</LinkToast>}
        </div>
    );
};
